import SVGBag from 'themesvg/bag.svg?inline';
import SVGBox from 'themesvg/box.svg?inline';
import SVGCart from 'themesvg/cart.svg?inline';
import SVGCash from 'themesvg/cash.svg?inline';
import SVGCategoryCurries from 'themesvg/category-curries.svg?inline';
import SVGCategoryExtras from 'themesvg/category-extras.svg?inline';
import SVGClock from 'themesvg/clock.svg?inline';
import SVGClose from 'themesvg/close.svg?inline';
import SVGCreditCard from 'themesvg/credit-card.svg?inline';
import SVGDatatrans from 'themesvg/datatrans.svg?inline';
import SVGDate from 'themesvg/date.svg?inline';
import SVGDelivery from 'themesvg/delivery.svg?inline';
import SVGDownload from 'themesvg/download.svg?inline';
import SVGDumplingSticks from 'themesvg/dumpling-sticks.svg?inline';
import SVGDumpling from 'themesvg/dumpling.svg?inline';
import SVGDumplingsBasket from 'themesvg/dumplings-basket.svg?inline';
import SVGDuplicate from 'themesvg/duplicate.svg?inline';
import SVGEdit from 'themesvg/edit.svg?inline';
import SVGEnvelope from 'themesvg/envelope.svg?inline';
import SVGFacebookNoBorder from 'themesvg/facebook-no-border.svg?inline';
import SVGFacebook from 'themesvg/facebook.svg?inline';
import SVGFilter from 'themesvg/filter.svg?inline';
import SVGGeoLocation from 'themesvg/geo-location.svg?inline';
import SVGHeartFull from 'themesvg/heart-full.svg?inline';
import SVGHeart from 'themesvg/heart.svg?inline';
import SVGInfo from 'themesvg/info.svg?inline';
import SVGInsta from 'themesvg/insta.svg?inline';
import SVGInstagram from 'themesvg/instagram.svg?inline';
import SVGLabelLeaf from 'themesvg/label-leaf.svg?inline';
import SVGLinkedin from 'themesvg/linkedin.svg?inline';
import SVGLoaderStack from 'themesvg/loader-stack.svg?inline';
import SVGLocation from 'themesvg/location.svg?inline';
import SVGLogoMadamesum from 'themesvg/logo-madamesum.svg?inline';
import SVGMap from 'themesvg/map.svg?inline';
import SVGMenu from 'themesvg/menu.svg?inline';
import SVGMidCircleChevronDown from 'themesvg/mid-circle-chevron-down.svg?inline';
import SVGMidCircleChevronLeft from 'themesvg/mid-circle-chevron-left.svg?inline';
import SVGMidCircleChevronRight from 'themesvg/mid-circle-chevron-right.svg?inline';
import SVGMidCircleChevronUp from 'themesvg/mid-circle-chevron-up.svg?inline';
import SVGMinus from 'themesvg/minus.svg?inline';
import SVGPaymentAmex from 'themesvg/payment-amex.svg?inline';
import SVGPaymentApplepay from 'themesvg/payment-applepay.svg?inline';
import SVGPaymentCoinify from 'themesvg/payment-coinify.svg?inline';
import SVGPaymentGooglepay from 'themesvg/payment-googlepay.svg?inline';
import SVGPaymentIcons from 'themesvg/payment-icons.svg?inline';
import SVGPaymentInvoice from 'themesvg/payment-invoice.svg?inline';
import SVGPaymentKlarna from 'themesvg/payment-klarna.svg?inline';
import SVGPaymentMastercard from 'themesvg/payment-mastercard.svg?inline';
import SVGPaymentPaypal from 'themesvg/payment-paypal.svg?inline';
import SVGPaymentTwint from 'themesvg/payment-twint.svg?inline';
import SVGPaymentVisa from 'themesvg/payment-visa.svg?inline';
import SVGPhone from 'themesvg/phone.svg?inline';
import SVGPinterest from 'themesvg/pinterest.svg?inline';
import SVGPlanzer from 'themesvg/planzer.svg?inline';
import SVGPlay from 'themesvg/play.svg?inline';
import SVGPlus from 'themesvg/plus.svg?inline';
import SVGPreparationBamboo from 'themesvg/preparation-bamboo.svg?inline';
import SVGPreparationPot from 'themesvg/preparation-pot.svg?inline';
import SVGPreparationSteamer from 'themesvg/preparation-steamer.svg?inline';
import SVGScanIllustrationPhone from 'themesvg/scan-illustration-phone.svg?inline';
import SVGSearch from 'themesvg/search.svg?inline';
import SVGSmallCheckmark from 'themesvg/small-checkmark.svg?inline';
import SVGSnowflake from 'themesvg/snowflake.svg?inline';
import SVGStarHalf from 'themesvg/star-half.svg?inline';
import SVGStar from 'themesvg/star.svg?inline';
import SVGSticks from 'themesvg/sticks.svg?inline';
import SVGTakeaway from 'themesvg/takeaway.svg?inline';
import SVGTiktok from 'themesvg/tiktok.svg?inline';
import SVGTrash from 'themesvg/trash.svg?inline';
import SVGTwitter from 'themesvg/twitter.svg?inline';
import SVGUser from 'themesvg/user.svg?inline';
import SVGUsers from 'themesvg/users.svg?inline';
import SVGWhatsapp from 'themesvg/whatsapp.svg?inline';
import SVGYoutube from 'themesvg/youtube.svg?inline';

export default {
	SVGBag,
	SVGBox,
	SVGCart,
	SVGCash,
	SVGCategoryCurries,
	SVGCategoryExtras,
	SVGClock,
	SVGClose,
	SVGCreditCard,
	SVGDatatrans,
	SVGDate,
	SVGDelivery,
	SVGDownload,
	SVGDumplingSticks,
	SVGDumpling,
	SVGDumplingsBasket,
	SVGDuplicate,
	SVGEdit,
	SVGEnvelope,
	SVGFacebookNoBorder,
	SVGFacebook,
	SVGFilter,
	SVGGeoLocation,
	SVGHeartFull,
	SVGHeart,
	SVGInfo,
	SVGInsta,
	SVGInstagram,
	SVGLabelLeaf,
	SVGLinkedin,
	SVGLoaderStack,
	SVGLocation,
	SVGLogoMadamesum,
	SVGMap,
	SVGMenu,
	SVGMidCircleChevronDown,
	SVGMidCircleChevronLeft,
	SVGMidCircleChevronRight,
	SVGMidCircleChevronUp,
	SVGMinus,
	SVGPaymentAmex,
	SVGPaymentApplepay,
	SVGPaymentCoinify,
	SVGPaymentGooglepay,
	SVGPaymentIcons,
	SVGPaymentInvoice,
	SVGPaymentKlarna,
	SVGPaymentMastercard,
	SVGPaymentPaypal,
	SVGPaymentTwint,
	SVGPaymentVisa,
	SVGPhone,
	SVGPinterest,
	SVGPlanzer,
	SVGPlay,
	SVGPlus,
	SVGPreparationBamboo,
	SVGPreparationPot,
	SVGPreparationSteamer,
	SVGScanIllustrationPhone,
	SVGSearch,
	SVGSmallCheckmark,
	SVGSnowflake,
	SVGStarHalf,
	SVGStar,
	SVGSticks,
	SVGTakeaway,
	SVGTiktok,
	SVGTrash,
	SVGTwitter,
	SVGUser,
	SVGUsers,
	SVGWhatsapp,
	SVGYoutube
}